// Browser extensions and page translators (Google Translate, element
// inspectors, ...) move or wrap DOM nodes React owns. React then calls
// removeChild/insertBefore with a node that is no longer where it expects and
// the browser throws NotFoundError, unmounting the whole app.
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
export function installDomGuard() {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      console.warn("domGuard: skipped removeChild of a node moved by an extension");
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      // Still insert the node (skipping it would leave a blank screen), just
      // at the end since the reference position no longer exists.
      console.warn("domGuard: reference node was moved, appending instead");
      return originalInsertBefore.call(this, newNode, null);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
